var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIonReceiptSharp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 2.0625L17.875 1.375L16.5 2.0625L15.125 1.375L13.75 2.0625L12.375 1.375L11 2.0625L9.625 1.375L8.25 2.0625L6.1875 1.375V12.3771H15.8125V18.2188C15.8125 19.5478 17.2335 20.625 18.5625 20.625H19.0781C20.4071 20.625 21.3125 19.5478 21.3125 18.2188V1.375L19.25 2.0625ZM11.709 10.3125L11.6875 8.9375H18.541L18.5625 10.3125H11.709ZM8.95898 6.875L8.9375 5.5H18.541L18.5625 6.875H8.95898Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4375 18.2188V13.75H0.6875V15.125C0.6875 17.2971 0.935859 18.2024 1.30883 18.8904C1.94176 20.0578 3.08773 20.625 4.8125 20.625H15.8125C15.8125 20.625 14.4375 19.7656 14.4375 18.2188Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIonReceiptSharp);
export default __webpack_public_path__ + "static/media/ion_receipt-sharp.d340b0bb3ad10ab900a86825d5385d8d.svg";
export { ForwardRef as ReactComponent };